// v4.4 — Analytics de la boucle contenu ↔ commerce (best effort, non bloquant).
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function trackCatalog(event, payload = {}) {
  try {
    const user_id = localStorage.getItem("civ_user_uuid") || null;
    axios.post(`${BACKEND_URL}/api/v3/catalogs/track`, { event, user_id, ...payload }).catch(() => {});
  } catch (_) {}
}
